import { render, staticRenderFns } from "./equipMent.vue?vue&type=template&id=45cdd4a3&scoped=true&"
import script from "./equipMent.vue?vue&type=script&lang=js&"
export * from "./equipMent.vue?vue&type=script&lang=js&"
import style0 from "./equipMent.vue?vue&type=style&index=0&id=45cdd4a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cdd4a3",
  null
  
)

export default component.exports